/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';

import { EcEnv } from '@castlery/config';
import { Box, Link, Sheet, Stack, Typography, useBreakpoints } from '@castlery/fortress';
import { selectSortedSocialUgc } from '@castlery/modules-product-domain';
import { getProductSocialUgcByVariantCommand } from '@castlery/modules-product-services';
import { useAppDispatch, useSelector } from '@castlery/shared-redux-store';
import { useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import { useWidgetCollection } from '../../hooks/use-widget-collection';
import { SocialUgcCarousel } from './components/social-ugc-carousel';
import { DYRecommendationCarousel } from '@castlery/shared-components';

interface ProductSocialUgcClientProps {
  pageType: 'pdp' | 'pla';
}

export function ProductSocialUgcClient({ pageType }: ProductSocialUgcClientProps) {
  // rtk query 调用 ugc 接口
  const dispatch = useAppDispatch();
  //   const product = useSelector(selectProduct);
  //   const variant = useSelector(selectVariant);
  //   const bundleVariant = useSelector(selectBundleVariants);
  //   const variantIds = useMemo(() => getVariantIds(product, variant, bundleVariant), [product, variant, bundleVariant]);
  useEffect(() => {
    dispatch(getProductSocialUgcByVariantCommand());
  }, [dispatch]);
  const socialSortedUgc = useSelector(selectSortedSocialUgc);
  const { desktop, mobile, tablet } = useBreakpoints();
  const { collection, product } = useWidgetCollection();

  if (socialSortedUgc?.length === 0) {
    return null;
  }

  return (
    <>
      {pageType === 'pdp' && (
        <LazyLoad
          offset={300}
          once
          placeholder={<Box sx={{ height: mobile ? '470px' : tablet ? '486px' : '592px' }} />}
        >
          <DYRecommendationCarousel selector_name="PDP Rec API - Top" />
        </LazyLoad>
      )}
      <Sheet
        variant="solid"
        sx={(theme) => ({
          py: desktop ? theme.spacing(9) : theme.spacing(7),
          px: desktop ? theme.spacing(7) : undefined,
        })}
      >
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Stack
            justifyContent={'center'}
            alignItems={'flex-start'}
            sx={{
              width: '100%',
            }}
            px={!desktop ? 6 : undefined}
          >
            <Typography level="h2" mb={2}>
              #AtHomewithCastlery
            </Typography>
            <Typography level="body1" variant="plain">
              Be inspired by real homes
              <Link
                href={`https://www.instagram.com/castlery${EcEnv.NEXT_PUBLIC_COUNTRY?.toLowerCase()}/?hl=en`}
                level="body1"
                variant="primary"
                target="_blank"
                sx={{
                  display: 'inline',
                  textDecoration: 'none',
                }}
              >
                {/* feature flag */}
                @castlery{EcEnv.NEXT_PUBLIC_COUNTRY?.toLowerCase()}
              </Link>
            </Typography>
          </Stack>
          <SocialUgcCarousel socialSortedUgc={socialSortedUgc} />
        </Stack>
      </Sheet>
    </>
  );
}
